import React from "react";
import PropTypes from "prop-types";

import Card from "../../component/card/Card";
import moment from "moment";
import HeaderTag from "../../component/smallComponents/HeaderTag";
import Button from "../../component/button/Button";

const CurrentRulesCard = ({
  currentRule,
  activateRule,
  deleteRule
}) => {
  const {
    shiftIn,
    shiftOut,
    activeNow,
    shiftType,
    // sickLeaves,
    bufferTime,
    halfDayCeil,
    // casualLeaves,
    willExpireOn,
    halfDayFloor,
    activationDate,
    privilegeLeaves,
    createdBy,
    shiftCode,
    needBasedLeaves,
    locationName,
    totalHourShift
  } = currentRule;

  return (
    <Card
      isHeader={true}
      header={
        <HeaderTag
          className={
            activeNow
              ? "card-header bg-success text-white"
              : "card-header bg-danger text-white"
          }
          title={locationName + " -> " + shiftCode}
          type="h6"
          isClassName={true}
        />
      }
    >
      <div className="table-responsive">
        <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
          <thead className="thead-light">
            <tr>
              <th className="text-center">Sr.No</th>
              <th className="text-center">Shift Type</th>
              <th className="text-center">In Time</th>
              <th className="text-center">Out Time</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-user text-center">1</td>
              <td className="table-user text-center">{shiftType}</td>
              <td className="table-user text-center">{shiftIn}</td>
              <td className="table-user text-center">{shiftOut}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <div className="table-responsive">
        <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
          <thead className="thead-light">
            <tr>
              <th className="text-center">Min H.D Hours</th>
              <th className="text-center">Max H.D Hours</th>
              <th className="text-center">Buffer Time</th>
              <th className="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-user text-center">
                {halfDayFloor}
              </td>
              <td className="table-user text-center">
                {halfDayCeil}
              </td>
              <td className="table-user text-center">{bufferTime}</td>
              <td className="table-user text-center">
                {totalHourShift}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <br />
      <div className="table-responsive">
        <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
          <thead className="thead-light">
            <tr>
              <th className="text-center">Sr.No</th>
              <th className="text-center">Type of Leave</th>
              <th className="text-center">Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-user text-center">1</td>
              <td className="table-user text-center">Privilege</td>
              <td className="table-user text-center">
                {privilegeLeaves}
              </td>
            </tr>
            <tr>
              <td className="table-user text-center">2</td>
              <td className="table-user text-center">Need Based</td>
              <td className="table-user text-center">
                {needBasedLeaves || 0}
              </td>
            </tr>
            {/* <tr>
              <td className="table-user text-center">3</td>
              <td className="table-user text-center">Sick</td>
              <td className="table-user text-center">{sickLeaves}</td>
            </tr> */}
          </tbody>
        </table>
      </div>
      <br />
      <div className="table-responsive">
        <table className="table table-bordered table-centered mb-0 table-hover w-100 dt-responsive nowrap">
          <thead className="thead-light">
            <tr>
              <th className="text-center">Sr.No</th>
              <th className="text-center">Activation date</th>
              <th className="text-center">Expire Date</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td className="table-user text-center">1</td>
              <td className="table-user text-center">
                {" "}
                {moment(activationDate).format("DD-MM-yyy")}
              </td>
              <td className="table-user text-center">
                {moment(willExpireOn).format("DD-MM-yyy")}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="mt-2">
        Created by : -{" "}
        {createdBy?.workerFirstName +
          " " +
          createdBy?.workerSurname || ""}
      </div>
      <div className="float-right">
        {activeNow ? (
          <Button
            title="Delete"
            type="button"
            // data-toggle="modal"
            isBackgroundColor={false}
            icon="mdi mdi-delete-forever mr-2"
            // data-target={`#full-width-modal${parentIndex}`}
            className="btn text-white btn-block btn-danger mt-2"
            onClick={deleteRule}
          />
        ) : (
          <Button
            type="button"
            title="Activate"
            onClick={activateRule}
            isBackgroundColor={false}
            className="btn text-white btn-block btn-warning mt-2"
          />
        )}
      </div>
    </Card>
  );
};

CurrentRulesCard.propTypes = {
  activateRule: PropTypes.func,
  deleteRule: PropTypes.func,
  // parentIndex: PropTypes.number.isRequired,
  currentRule: PropTypes.object.isRequired
};

export default CurrentRulesCard;
